import { apiConfig } from '../../services/api';

export const CM_BASE_URL = apiConfig.serviceApiCM || apiConfig.serviceApi;
export const CM_BASE_ROUTE = '/app/cm';
export const CASE_LIST_ROUTES = {
  BY_DEPARTMENT: 'cases-by-department',
  BY_INVESTIGATOR: 'cases-by-investigator'
};

export const ALERT_LIST_ROUTE = 'alerts';
export const CASE_LIST_ROUTE = 'cases';

export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;
export const HISTORY_ITEMS_PER_PAGE = 10;
export const CUSTOMERS_PER_PAGE = 10;
export const USER_GROUP_PER_PAGE = 5;
export const ALERT_STATUSES = [
  'UNASSIGNED',
  'ASSIGNED',
  'WORK_IN_PROGRESS',
  'RE_OPENED',
  'NO_ISSUE',
  'HIBERNATE',
  'AUTO_HIBERNATE'
];

export const ALERT_SOURCE_IDS = {
  TMSAM: 'TMSAM',
  TMSAM_ANOMALY: 'TMSAM_ANOMALY',
  NSIAD: 'NSIAD',
  NSSAM: 'NSSAM',
  TSSAM: 'TSSAM',
  CRS_FIRST_TIME_RISK: 'CRS_FIRST_TIME_RISK',
  CRS_PERIODIC_REVIEW: 'CRS_PERIODIC_REVIEW',
  CRS_RISK_CHANGE: 'CRS_RISK_CHANGE',
  CRS_OTHERS: 'CRS_OTHERS',
  TMIAD: 'TMIAD',
  NSIAD_RUN_INSTANCE: 'NSIAD_RUN_INSTANCE',
  TMIAD_RUN_INSTANCE: 'TMIAD_RUN_INSTANCE',
  TSIAD: 'TSIAD',
  CRS_PRIORITISE_ALERT: 'CRS_PRIORITISE_ALERT',
  FRAUDIAD: 'FRAUDIAD',
  RTFRAUDIAD: 'RTFRAUDIAD',
  RTFRAUDIAD_BATCH: 'RTFRAUDIAD_BATCH',
  ON_DEMAND_NS_SINGLE: 'ON_DEMAND_NS_SINGLE',
  ON_DEMAND_NS_BATCH: 'ON_DEMAND_NS_BATCH',
  PS: 'PS'
};

export const RT_FRAUD_SOURCE_IDS = ['RTFRAUDIAD', 'RTFRAUDIAD_BATCH'];

export const ALERT_SOURCE_APPS = {
  TM: 'Transaction Monitoring',
  NS: 'Name Screening',
  TS: 'Transaction Screening',
  CRS: 'Customer Risk Scoring',
  PS: 'Prospect Screening'
};

export const ALERT_SOURCE_APP_BY_SOURCE_ID = {
  [ALERT_SOURCE_IDS.TMSAM]: ALERT_SOURCE_APPS.TM,
  [ALERT_SOURCE_IDS.TMSAM_ANOMALY]: ALERT_SOURCE_APPS.TM,
  [ALERT_SOURCE_IDS.NSIAD]: ALERT_SOURCE_APPS.NS,
  [ALERT_SOURCE_IDS.NSSAM]: ALERT_SOURCE_APPS.NS,
  [ALERT_SOURCE_IDS.TSSAM]: ALERT_SOURCE_APPS.TS,
  [ALERT_SOURCE_IDS.CRS_FIRST_TIME_RISK]: ALERT_SOURCE_APPS.CRS,
  [ALERT_SOURCE_IDS.CRS_PERIODIC_REVIEW]: ALERT_SOURCE_APPS.CRS,
  [ALERT_SOURCE_IDS.CRS_RISK_CHANGE]: ALERT_SOURCE_APPS.CRS,
  [ALERT_SOURCE_IDS.CRS_OTHERS]: ALERT_SOURCE_APPS.CRS,
  [ALERT_SOURCE_IDS.TMIAD]: ALERT_SOURCE_APPS.TM,
  [ALERT_SOURCE_IDS.NSIAD_RUN_INSTANCE]: ALERT_SOURCE_APPS.NS,
  [ALERT_SOURCE_IDS.TMIAD_RUN_INSTANCE]: ALERT_SOURCE_APPS.TM,
  [ALERT_SOURCE_IDS.TSIAD]: ALERT_SOURCE_APPS.TS,
  [ALERT_SOURCE_IDS.PS]: ALERT_SOURCE_APPS.PS
};

export const ALERT_LEVELS = ['LOW', 'GOOD', 'HIGH'];

export const ALERT_LEVEL_COLORS = {
  [ALERT_LEVELS[0]]: '#71C969',
  [ALERT_LEVELS[1]]: '#E29840',
  MEDIUM: '#E29840',
  [ALERT_LEVELS[2]]: '#DF6057'
};

export const CASE_CLOSURE_STATUSES = [
  'ISSUE_NOT_STR',
  'NO_ISSUE',
  'ISSUE_REPORT_STR'
];

export const CASE_STR_STATUS = ['ISSUE_REPORT_STR'];
export const CASE_NOTSTR_STATUS = ['ISSUE_NOT_STR', 'NO_ISSUE'];

export const CASE_STATUSES = [
  'UNASSIGNED',
  'ASSIGNED',
  'WORK_IN_PROGRESS',
  'ON_HOLD',
  'RE_OPENED',
  ...CASE_CLOSURE_STATUSES
];

export const DEFAULT_STATUSES = [
  'UNASSIGNED',
  'ASSIGNED',
  'WORK_IN_PROGRESS',
  'ON_HOLD',
  'RE_OPENED',
  'NO_ISSUE',
  'HIBERNATE',
  'AUTO_HIBERNATE',
  'ISSUE_NOT_STR',
  'ISSUE_REPORT_STR'
];

export const DEFAULT_DATE_RANGE_DAYS = 30;

export const ALERT_STATUS_TRANSITIONS = {
  UNASSIGNED: ['ASSIGNED', 'HIBERNATE'],
  ASSIGNED: ['UNASSIGNED', 'WORK_IN_PROGRESS', 'NO_ISSUE', 'HIBERNATE'],
  RE_OPENED: ['ASSIGNED', 'NO_ISSUE'],
  WORK_IN_PROGRESS: ['NO_ISSUE', 'HIBERNATE'],
  NO_ISSUE: ['RE_OPENED'],
  HIBERNATE: ['ASSIGNED'],
  AUTO_HIBERNATE: ['ASSIGNED']
};

export const CASE_ALERT_STATUS_TRANSITIONS = {
  UNASSIGNED: ['ASSIGNED', 'NO_ISSUE'],
  ASSIGNED: [
    'WORK_IN_PROGRESS',
    'ISSUE_NOT_STR',
    'ISSUE_REPORT_STR',
    'NO_ISSUE'
  ],
  RE_OPENED: ['ASSIGNED', 'ISSUE_NOT_STR', 'ISSUE_REPORT_STR', 'NO_ISSUE'],
  WORK_IN_PROGRESS: [
    'ON_HOLD',
    'ISSUE_NOT_STR',
    'ISSUE_REPORT_STR',
    'NO_ISSUE'
  ],
  ON_HOLD: [
    'WORK_IN_PROGRESS',
    'ISSUE_NOT_STR',
    'ISSUE_REPORT_STR',
    'NO_ISSUE'
  ],
  ISSUE_NOT_STR: ['RE_OPENED'],
  ISSUE_REPORT_STR: ['RE_OPENED'],
  NO_ISSUE: ['RE_OPENED']
};

export const DOWNLOAD_SCREENS = {
  CASES_BY_DEPARTMENT: 'cases',
  CASES_BY_INVESTIGATOR: 'cases',
  ALERT_LIST: 'alerts',
  ALERT_RETRY_HISTORY: 'retry-history'
};

export const HISTORY_ITEM_ACTION_TYPES = {
  CHANGE_STATUS: 'CHANGE_STATUS',
  ASSIGN_USER: 'ASSIGN_USER',
  ASSIGN_DEPARTMENT: 'ASSIGN_DEPARTMENT',
  ADD_NOTE: 'ADD_NOTE',
  ATTACH_FILE: 'ATTACH_FILE',
  CHECK_REQUESTED: 'CHECK_REQUESTED',
  CHECK_PASSED: 'CHECK_PASSED',
  CHECK_NOT_PASSED: 'CHECK_NOT_PASSED',
  MERGE_ALERT_TO_CASE: 'MERGE_ALERT_TO_CASE',
  CONVERT_ALERT_TO_CASE: 'CONVERT_ALERT_TO_CASE',
  CHANGE_CASE_NAME: 'CHANGE_CASE_NAME',
  AUTO_ASSIGN_CASE: 'AUTO_ASSIGN_CASE',
  AUTO_MERGE_ALERT_TO_CASE: 'AUTO_MERGE_ALERT_TO_CASE'
};

export const REVIEW_STATUSES = {
  CHECK_NEEDED: 'CHECK_NEEDED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CHECK_NOT_NEEDED: 'CHECK_NOT_NEEDED'
};

export const CASE_TYPE = {
  AUTOMATION_CASE: 'AUTOMATION_CASE',
  MANUAL_CASE: 'MANUAL_CASE'
};

export const STR_POLLING_INTERVAL_MS = 10000;

export const SETTINGS_LIST_ROUTES = {
  EMAIL_PREFERENCES: 'email-preferences',
  USER_GROUP: 'user-group',
  GENERAL_SETTINGS: 'general-settings',
  AUTOMATION: 'automation',
  WORKFLOW_STATUS: 'alert-case-status-name',
  AGE_SETTINGS: 'age-settings'
};

export const CASE_SEARCH_OPTIONS = [
  { label: 'Customer ID', value: 'customer-id' },
  { label: 'Customer Name', value: 'customer-name' },
  { label: 'Case ID', value: 'case-id' },
  { label: 'Case Subject', value: 'case-subject' },
  { label: 'Alert ID', value: 'alert-id' },
  { label: 'Account Number', value: 'acc-no' },
  { label: 'Investigation Notes', value: 'notes' },
  { label: 'Transaction ID', value: 'transaction-id' },
  { label: 'Customer ID Number', value: 'party-id-no' },
  { label: 'Merchant Reg Number', value: 'registered-number' }
];

export const APPROVAL_STATUSES = {
  CHECK_NEEDED: 'CHECK_NEEDED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CHECK_NOT_NEEDED: 'CHECK_NOT_NEEDED'
};

export const USER_ROLES = {
  ADMIN: 'ADMIN',
  CHECKER: 'CHECKER',
  SUPERVISOR: 'SUPERVISOR',
  INVESTIGATOR: 'INVESTIGATOR',
  INVESTIGATOR_PLUS: 'INVESTIGATOR_PLUS'
};

export const PLACEHOLDER_INPUT = 'Please input';
export const PLACEHOLDER_SELECT = 'Please select';

export const REPORTS_ROUTES = {
  REGULATORY_REPORT: 'regulatory-report',
  OPERATIONAL_REPORT: 'operational-report'
};

export const DATE_FORMAT = 'DD/MM/YYYY';

export const APPROVAL_STATUS_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Approved by the User', value: 'APPROVED' },
  { label: 'Pending Approval', value: 'CHECK_NEEDED' },
  { label: 'Rejected by the User', value: 'REJECTED' },
  { label: 'Closed Without Approval', value: 'CHECK_NOT_NEEDED' },
  { label: 'Others', value: 'NA' }
];

export const CHARACTER_COUNT = 50;
export const PARTY_NAME_CHARACTER_COUNT = 300;
export const ALERT_SCORE_DEFAULT_VALUE = [50.0, 100.0];
export const NOTE_MAX_ALLOWED_CHARACTERS = 5000;

export const AGE_METHOD_NAMES = {
  HOUR24: 'METHOD_24_HOURS',
  MIDNIGHT: 'METHOD_MIDNIGHT',
  REOPENED_DATE: 'REOPENED_DATE',
  DEFAULT_DATE: 'CREATED_DATE'
};

export const WHITELIST_STATUS = {
  APPROVED: 'Approved',
  PENDING_APPROVAL: 'Pending Approval',
  REJECTED: 'Rejected'
};

export const AUTOMATION_ASSIGN_TYPES = {
  BY_WORKLOAD: 'BY_WORKLOAD',
  BY_USER: 'BY_USER',
  BY_BEHAVIOUR: 'BY_BEHAVIOUR'
};

export const AUTOMATION_TYPES = {
  DETECTION: 'DETECTION',
  PREVENTION: 'PREVENTION',
  REAL_TIME_SCREENING: 'REAL_TIME_SCREENING',
  PROSPECT_SCREENING: 'PROSPECT_SCREENING'
};

export const WHITELIST_TYPES = {
  USER_GENERATED: 'Custom',
  SYSTEM_GENERATED: 'Default'
};

export const MESSAGE_DURATION = 7;
